import React, { Component } from "react";
import { Nav } from "../../Components/index";
import { Footer } from "../../Containers/index";
import ArrowElbow from "../../assets/icons/arrow-elbow-down-right.svg";
import ImgAbout from "../../assets/images/startup-business.png";
import classes from "./About.module.css";

class About extends Component {
  state = {
    approachs: [
      "Entrepreneurship",
      "Marketing",
      "Networking",
      "Innovation",
      "Incubation",
    ],
  };

  render() {
    let approachList = this.state.approachs.map((approach, index) => {
      return (
        <li key={index} className={classes.AboutListItem}>
          <img src={ArrowElbow} alt="" className={classes.AboutListItemImg} />
          <p className={classes.AboutListItemText}>{approach}</p>
        </li>
      );
    });

    return (
      <section className={classes.About}>
        <Nav />
        <div className={classes.AboutContent}>
          <div>
            <h2 className={classes.AboutTitle}>
              <span>Who</span> we are
            </h2>
            <p className={classes.AboutText}>
              All Africa Hub is an incubation center founded in Addis Ababa
              capital city of Ethiopia where most of Africa and international
              organization’s head quarter is found and has flight destinations
              to most of Africa countries. It has moderate climate which is good
              for life. Best suit for market expansion to East Africa and to its
              neighbors.
            </p>
          </div>
          {/* TEMP : PLACEHOLDER FOR THE ORGINAL IMAGE */}
          <img src={ImgAbout} alt="" className={classes.AboutImg} />
          <div>
            <h3 className={classes.AboutSubTitle}>Our approach</h3>
            <ul className={classes.AboutList}>{approachList}</ul>
          </div>
        </div>
        <Footer />
      </section>
    );
  }
}

export default About;
